export const DELETE_TABLES='DELETE_TABLES'
export const DELETE_TABLES_SUCCESS= 'DELETE_TABLES_SUCCESS'
export const DELETE_TABLES_ERROR= 'DELETE_TABLES_ERROR'

export const DeleteTables= (data) => ({
    type: DELETE_TABLES,
    payload: data
});
